import BaseApi from "./BaseApi";
import { logError } from "../utils/errorLogger";

class PaymentApi extends BaseApi {
  constructor() {
    super("paiements"); // Set the endpoint to "paiements"
  }

  // Get hotel payment settings
  async getHotelPaymentSettings(hotelId) {
    try {
      const response = await this.getApiInstance(true).get(
        `/${this.endpoint}/hotel/${hotelId}/settings`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Update hotel payment settings
  async updateHotelPaymentSettings(hotelId, settings) {
    try {
      const response = await this.getApiInstance(true).put(
        `/${this.endpoint}/hotel/${hotelId}/settings`,
        settings
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Fetch all payment modes (with champs_saisie)
  async getAllModes() {
    const response = await this.getApiInstance(true).get('/paiements');
    return response.data;
  }

  // Fetch all payment modes with champs_saisie
  async getAllModesWithChamps() {
    const response = await this.getApiInstance(true).get('/paiements/with-champs');
    return response.data;
  }

  // Update hotel paiement_par field (calls hotel endpoint)
  async updateHotelPaiementPar(hotelId, paiementPar) {
    try {
      const response = await this.getApiInstance(true).put(
        `/${hotelId}/paiement-par`,
        { paiement_par: paiementPar }
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }
}

export default new PaymentApi();